var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{attrs:{"title":"选择性别：","cancel-text":"取消","actions":_vm.actions,"lazy-render":"","safe-area-inset-bottom":""},on:{"select":_vm.onSelected},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}})
}
var staticRenderFns = []

export { render, staticRenderFns }